import { Check, TriangleAlert } from "lucide-react";

import {
  IgCoreTextColors,
  IgIconColors,
} from "@intelligems/ig-design-tokens/constants";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { CircularProgress, Stack } from "@mui/material";

import type { RuleSaveStatus } from "./ruleSaveApplyState";

/**
 * The rule's save status, at the right end of the back-link row: 12px
 * placeholder text after a 14px icon, 8px apart. Only the reopened-unapplied
 * case turns warning.
 */
export const RuleDraftSaveStatus = ({
  status,
}: {
  status: RuleSaveStatus | null;
}) => {
  if (status === null) {
    return null;
  }
  const color =
    status.tone === "warning"
      ? IgIconColors.warning
      : IgCoreTextColors.placeholder;
  const Icon = status.tone === "warning" ? TriangleAlert : Check;

  return (
    <Stack
      role="status"
      aria-live="polite"
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ color }}
    >
      {status.kind === "saving" ? (
        <CircularProgress size={12} color="inherit" aria-hidden />
      ) : (
        <Icon size={14} aria-hidden />
      )}
      <IgTypography
        variant="caption"
        sx={{ color, fontSize: "12px", lineHeight: "18px" }}
      >
        {status.text}
      </IgTypography>
    </Stack>
  );
};
